<div class="home-container">
    <div class="welcome-section">
        <h1 class="mat-display-2">Üdvözöljük az Egészségügyi Rendelőnkben</h1>
        <p class="mat-subheading-2">Az Ön megbízható partnere az egészségügyben</p>
    </div>

    <div class="content-grid">
        <mat-card class="info-card">
            <mat-card-header>
                <mat-icon mat-card-avatar>info</mat-icon>
                <mat-card-title>Rólunk</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Egészségügyi Rendelőnk elkötelezett a kiváló orvosi ellátás biztosítása mellett közösségünk számára. Tapasztalt szakembereink csapata azért van, hogy Ön a lehető legjobb kezelést kapja.</p>
            </mat-card-content>
        </mat-card>

        <mat-card class="info-card">
            <mat-card-header>
                <mat-icon mat-card-avatar>medical_services</mat-icon>
                <mat-card-title>Szolgáltatásaink</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-list>
                    <mat-list-item>
                        <mat-icon matListItemIcon>check_circle</mat-icon>
                        <span matListItemTitle>Általános vizsgálatok</span>
                    </mat-list-item>
                    <mat-list-item>
                        <mat-icon matListItemIcon>check_circle</mat-icon>
                        <span matListItemTitle>Gyermekgyógyászat</span>
                    </mat-list-item>
                    <mat-list-item>
                        <mat-icon matListItemIcon>check_circle</mat-icon>
                        <span matListItemTitle>Nőgyógyászat</span>
                    </mat-list-item>
                    <mat-list-item>
                        <mat-icon matListItemIcon>check_circle</mat-icon>
                        <span matListItemTitle>Sürgősségi ellátás</span>
                    </mat-list-item>
                    <mat-list-item>
                        <mat-icon matListItemIcon>check_circle</mat-icon>
                        <span matListItemTitle>Szakorvosi beutalók</span>
                    </mat-list-item>
                </mat-list>
            </mat-card-content>
        </mat-card>

        <mat-card class="info-card">
            <mat-card-header>
                <mat-icon mat-card-avatar>contact_phone</mat-icon>
                <mat-card-title>Kapcsolat</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="contact-info">
                    <p><mat-icon>location_on</mat-icon> 1234 Budapest, Egészség utca 123.</p>
                    <p><mat-icon>phone</mat-icon> (06) 1 234-5678</p>
                    <p><mat-icon>email</mat-icon> kapcsolat (at) rendelo.hu</p>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
